export const subscriptionStatusLiterals = [
  'unlimited', // the user has an active unlimited subscription
  'unsubscribed', // the user has *NO* subscription
] as const;

export type SubscriptionStatuses = (typeof subscriptionStatusLiterals)[number];
